import { render } from "./EditExam.vue?vue&type=template&id=7ef6121e"
import script from "./EditExam.vue?vue&type=script&lang=js"
export * from "./EditExam.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mohamedyousef/projects/online_education/projects/web-applications/admin-panel-for-education-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__